import { inject } from '@angular/core';
import {
  ITariffServiceAreaWithCredentialType,
  TARIFF_CREDENTIALS_WITH_TYPE_SCHEMA,
} from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../app-config.service';
import { IListGateway } from '../gateways';

export class TariffAreaGateway implements IListGateway<
  never,
  IApiResponse<ITariffServiceAreaWithCredentialType[]>
> {
  private readonly configService: AppConfigService = inject(AppConfigService);
  private readonly restCallBuilder: RestCallBuilder<
    ITariffServiceAreaWithCredentialType[]
  > = new RestCallBuilder<ITariffServiceAreaWithCredentialType[]>([]);

  list(): Observable<IApiResponse<ITariffServiceAreaWithCredentialType[]>> {
    return this.restCallBuilder
      .getExternal(this.configService.get().general.tariffUrl + '/tariff-area/')
      .validate(
        API_RESPONSE_SCHEMA(TARIFF_CREDENTIALS_WITH_TYPE_SCHEMA),
        'TariffArea.get'
      )
      .handleMessages()
      .build();
  }
}
